import type * as AddToBasket from '@ori-events/add-to-basket';
import type { PositionData } from '@ori/analytics-data';

import addToBasket from '../helpers/addToBasket';
import getBuyingURLandMethod from '../helpers/getBuyingURLandMethod';

interface Data extends AddToBasket.Data, PositionData {}

export default async ({
  detail: {
    itemCode,
    quantity,
    originalItemCode,
    replacementType,
    method: addToBasketMethod,
    placement,
  },
}: CustomEvent<Data>) => {
  const { url, method } = getBuyingURLandMethod(addToBasketMethod);

  return addToBasket(
    url,
    {
      itemCode,
      quantity,
      originalItemCode,
      replacementType,
      placement,
    },
    method,
  );
};
